function removeBrTags() {
    if (window.innerWidth < 767) {
      document.querySelectorAll('.collection_page_richtext h3.rich-text-image__heading.rte br')
        .forEach(br => br.remove());
    }
  }

  // Run on load
  removeBrTags();

  // Run again if screen resizes
  window.addEventListener('resize', removeBrTags);